<template>
    <div>
        <a v-if="isSuccess" :href="photo_link" target="_blank">
            <img :src="photo_link" alt="Photo" class="photo-placeholder">
        </a>
        <img v-else :src="iconImageNotFound" alt="Photo" class="photo-placeholder">
    </div>
</template>

<script>
    let iconImageNotFound = require('../../assets/img/image_not_found.png');
    export default
    {
        props: ['photo_link'],
        components: {},
        data() {
            return {
                isSuccess: false,
                iconImageNotFound: iconImageNotFound,
            };
        },
        mounted() {
            let image = new Image();
            image.addEventListener('load', this.onImageLoad);
            image.src = this.photo_link;
        },
        methods: {
            onImageLoad: function() {
                this.isSuccess = true;
            }
        }
    }
</script>

<style lang="sass">
    .photo-placeholder {
        height: auto;
        width: auto;
        max-width: 80px;
        max-height: 80px;
        margin: auto;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// productPhoto.vue?543d4d81